import { Getter } from "vuex";
import { IState } from './state';

const filters: Getter<IState, IState> = (state) => state.filters;
const filterText: Getter<IState, IState> = (state) => state.filterText;
const total: Getter<IState, IState> = (state) => state.total;
const items: Getter<IState, IState> = (state) => state.items;
const numberToShow: Getter<IState, IState> = (state) => state.numberToShow;
const query: Getter<IState, IState> = (state) => state.query;
const sort: Getter<IState, IState> = (state) => state.sort;

export default {
	filters,
	total,
	items,
	numberToShow,
	query,
	filterText,
	sort
}
